import React, { Component } from 'react';
import {
    Button, FormControl, FormGroup, InputGroup, PageHeader,
    Modal, Glyphicon, Label, Form, ControlLabel, Alert
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, InsertModalHeader } from 'react-bootstrap-table';
import { Link } from "react-router-dom";
import Switch from "react-switch";
import Loader from "react-loader-spinner";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import RenderMenu from '../../common/PdfRenderMenu'
import ColumnFormatter from '../../common/ColumnFormatter';
import './../../common/Common.css';
import Enums from './../../common/Enums';
import { AddressComponent, PersonalInformationComponent } from '../../common/FunctionComponents';

export class Applicant extends Component {
    displayName = "Applicant Information"

    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id,
            isActive: true,
            gender: '',
            firstName: '',
            middleName: '',
            lastName: '',
            dateOfBirth: '1990-01-01',
            nationality: '',
            streetNumberName: '',
            unitType: '',
            unitNumber: '',
            city: '',
            state: '',
            zipCode: '',
            country: 'USA',
            province: '',
            postalCode: '',
            phoneNumber: '',
            email: '',
            aNumber: '',
            notes: '',
            cases: [],
            audioRecordings: [],
            enableText: false,
            enableCourtDate: false,
            agencyFeatures: [],
            caseType: '',
            caseId: '',

            loading: true,
            isSubmitting: false,
            showSavedMessage: false,
            showErrorMessage: false,
            errorMessages: [],

            showAddCaseModal: false,

            uploadFileName: '',
            showUploadSuccess: false,
            isDownloadingDocument: false,
            showDownloadError: false,
            showPdfModal: false,

            isCheckingCaseStatus: false,
            isCourtDateCheckEnabled: false
        }

        this.refreshData();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleIsActiveCheckboxChange = this.handleIsActiveCheckboxChange.bind(this);
        this.handleCourtDateCheckboxChange = this.handleCourtDateCheckboxChange.bind(this);
        this.handleShowAddCaseModal = this.handleShowAddCaseModal.bind(this);
        this.handleHideAddCaseModalClose = this.handleHideAddCaseModalClose.bind(this);
        this.handleAddCaseSubmit = this.handleAddCaseSubmit.bind(this);
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.handleDismissAlert = this.handleDismissAlert.bind(this);
        this.closePdfModal = this.closePdfModal.bind(this);
    }


    closePdfModal() {
        this.setState({ pdfBlob: null });
    }
    componentDidMount() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
        };

        fetch(`api/AgencyService/${localStorage.getItem('agency_key')}/`, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.setState({ agencyFeatures: data.features });
            });
        this.getListOfDocuments();
    }

    getListOfDocuments() {
        let url = `api/DocumentService/${localStorage.getItem('agency_key')}/${this.state.id}`;

        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    documentsSelected: data
                });
            });
    }

    refreshData() {

        if (!this.state.id)
            return;

        let url = `api/PollService/${localStorage.getItem('agency_key')}/client/${this.state.id}`;
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
        };

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {

                let yourDate = 'T';

                if (data.dateOfBirth)
                    yourDate = data.dateOfBirth;

                this.setState({
                    id: data.id,
                    gender: data.gender,
                    firstName: data.firstName,
                    middleName: data.middleName,
                    lastName: data.lastName,
                    dateOfBirth: yourDate.split('T')[0],
                    nationality: data.nationality,
                    streetNumberName: data.addresses[0].streetNumberName,
                    unitType: data.addresses[0].unitType,
                    unitNumber: data.addresses[0].unitNumber,
                    city: data.addresses[0].city,
                    state: data.addresses[0].state,
                    zipCode: data.addresses[0].zipCode,
                    country: data.addresses[0].country,
                    province: data.addresses[0].province,
                    postalCode: data.addresses[0].postalCode,
                    phoneNumber: data.phoneNumber,
                    email: data.email,
                    cases: data.cases,
                    audioRecordings: data.audioRecordings,
                    enableText: data.enableText,
                    isCourtDateCheckEnabled: data.isCourtDateCheckEnabled,
                    aNumber: data.aNumber,
                    notes: data.notes,
                    isActive: data.isActive,
                    lastModifiedDate: data.lastModifiedDate,
                    loading: false
                });
            });

        this.getListOfDocuments();
    }

    handleShowAddCaseModal() {
        this.setState({ showAddCaseModal: true });
    }

    handleHideAddCaseModalClose() {
        this.setState({ showAddCaseModal: false });
    }

    handlePhoneNumberChange(value, data, event, formattedValue) {

        this.setState({ phoneNumber: value });
    }

    handleInputChange(evt) {
        evt.preventDefault();
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleIsActiveCheckboxChange(evt) {
        this.setState({ isActive: !this.state.isActive });
    }

    handleCourtDateCheckboxChange(evt) {
        this.setState({ isCourtDateCheckEnabled: !this.state.isCourtDateCheckEnabled });
    }

    handleCheckboxChange(evt) {
        this.setState({ enableText: !this.state.enableText });
    }

    handleDismissAlert(evt) {
        this.setState({ showErrorMessage: false });
    }

    handleAddCaseSubmit(event) {

        event.preventDefault();

        let row = [];
        row.id = 0;
        row.status = 'New Case';
        row.applicantCaseId = this.state.caseId;
        row.caseType = this.state.caseType;

        this.postCase(row);
        this.handleHideAddCaseModalClose();

    }

    handleSubmit(event) {

        this.setState({
            isSubmitting: true,
            showSavedMessage: false,
            showErrorMessage: false,
            errorMessages: []
        });

        event.preventDefault();

        let id = this.state.id ? this.state.id : "";

        let url = `api/PollService/${localStorage.getItem('agency_key')}/client/${id}`;
        fetch(url,
            {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
                body: JSON.stringify({
                    id: this.state.id,
                    gender: this.state.gender,
                    firstName: this.state.firstName,
                    middleName: this.state.middleName,
                    lastName: this.state.lastName,
                    dateOfBirth: this.state.dateOfBirth,
                    nationality: this.state.nationality,
                    email: this.state.email,
                    phoneNumber: this.state.phoneNumber,
                    addresses: [
                        {
                            streetNumberName: this.state.streetNumberName,
                            unitType: this.state.unitType,
                            unitNumber: this.state.unitNumber,
                            city: this.state.city,
                            state: this.state.state,
                            zipCode: this.state.zipCode,
                            country: this.state.country,
                            province: this.state.province,
                            postalCode: this.state.postalCode
                        }
                    ],
                    aNumber: this.state.aNumber,
                    notes: this.state.notes,
                    enableText: this.state.enableText,
                    isCourtDateCheckEnabled: this.state.isCourtDateCheckEnabled,
                    isActive: this.state.isActive
                })
            })
            .then(response => response.json())
            .then(data => {
                var messages = [];

                data.errorMessages.map(x => messages.push(x.errorMessage));

                if (!data.showErrorMessage)
                    this.setState({ id: data.result });

                this.setState({
                    isSubmitting: false,
                    showSavedMessage: !data.showErrorMessage,
                    showErrorMessage: data.showErrorMessage,
                    errorMessages: messages
                });

                if (!data.showErrorMessage)
                    this.refreshData();
            });


    }

    dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }

    postCase(data) {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ClientId: this.state.id,
                ApplicantCaseId: data.applicantCaseId,
                CaseType: data.caseType,
                Status: data.status
            })
        };

        let url = `api/PollService/${localStorage.getItem('agency_key')}/client/${this.state.id}/cases`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.refreshData();
            });
    }

    onAfterSaveCell = (row, cellName, cellValue) => {

        //validate fields
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ClientId: this.state.id,
                Id: row.id,
                ApplicantCaseId: row.applicantCaseId,
                CaseType: row.caseType,
                Status: row.status
            })
        };

        let url = `api/PollService/${localStorage.getItem('agency_key')}/client/${this.state.id}/cases/edit`;

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(data => {
                this.refreshData();
            });
    }

    onAddRow = row => {
        row.id = 0;
        row.status = 'New Case';

        this.postCase(row);
    }

    createCustomModalHeader(closeModal, save) {
        return (
            <InsertModalHeader
                title='Add Case' />
        );
    };

    asCheckCaseStatusButton(cell, row, enumObjec, rowIndex) {
        var caseId = row.id;
        return (
            <Button bsStyle="info" type="button" onClick={() => {
                this.setState({ isCheckingCaseStatus: true });
                let url = `api/PollService/${localStorage.getItem('agency_key')}/case/${caseId}/update`;

                const requestOptions = {
                    method: 'GET',
                    headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
                };

                fetch(url, requestOptions)
                    .then(response => response.json())
                    .then(data => this.setState({ isCheckingCaseStatus: false }));
            }}>
                <Glyphicon glyph='th' />
            </Button>
        )
    }

    blobCallback = base64data => {
        this.setState({ pdfBlob: base64data });
    }

    downloadDocument(documentName, url) {
        this.setState({ isDownloadingDocument: true, showDownloadError: false });

        let fileExtension = ".pdf";
        let isPdf = true;
        let fileDocName = documentName;

        function endsWith(str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        if (endsWith(documentName, "docx")) {
            fileExtension = ".docx";
            isPdf = false;
            fileDocName = fileDocName.split('.').slice(0, -1).join('.');
        }

        let fileName = fileDocName + '-' + this.state.firstName + this.state.lastName + fileExtension;
        this.setState({ uploadFileName: fileName });

        fetch(url)
            .then(response => {

                if (!response.ok) {
                    this.setState({ showDownloadError: true });
                    return;
                }

                response.blob().then(blob => {

                    if (isPdf) {
                        var blobToBase64 = function (blob, callback) {
                            var reader = new FileReader();
                            reader.onload = function () {
                                var dataUrl = reader.result;
                                var base64 = dataUrl.split(',')[1];
                                callback(base64);
                            };
                            reader.readAsDataURL(blob);
                        };

                        blobToBase64(blob, this.blobCallback);
                    }
                    else {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = fileName;
                        a.click();
                    }
                });

                this.setState({ isDownloadingDocument: false, showDownloadError: false });


                this.getListOfDocuments();
            });
    }

    asSavedDocumentPrintButton(cell, row, enumObject, rowIndex) {
        let url = `api/DocumentService/${localStorage.getItem('agency_key')}/download/${row.documentName}/${this.state.id}?saved=true&authToken=Bearer ${this.props.auth.getAccessToken()}`;

        return (
            <Button bsStyle="info" type="button"
                onClick={() => this.downloadDocument(row.documentName, url)}><Glyphicon glyph="download" /></Button>
        )
    }

    asNewDocumentPrintButton(cell, row, enumObject, rowIndex) {
        let url = `api/DocumentService/${localStorage.getItem('agency_key')}/download/${row.documentName}/${this.state.id}?saved=false&authToken=Bearer ${this.props.auth.getAccessToken()}`;

        return (
            <Button bsStyle="info" type="button"
                onClick={() => this.downloadDocument(row.documentName, url, false)}><Glyphicon glyph="download" /></Button>
        )
    }

    checkAllCases() {
        const cases = [];
        this.state.cases.map((item, i) => cases.push(item.id));

        let url = `api/PollService/${localStorage.getItem('agency_key')}/case/updates`;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cases)
        };

        fetch(url, requestOptions)
            .then(response => response.json());

        window.location.reload();
    }

    makeCall() {
        let url = `api/PollService/${localStorage.getItem('agency_key')}/autocall/${this.state.id}`;

        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(url, requestOptions);
    }

    handleModalClose(closeModal) {
        closeModal();
    }

    render() {
        return (
            <div>
                <PageHeader>
                    Applicant <small>{this.state.firstName + ' ' + this.state.lastName}</small>
                </PageHeader>

                <div className="flex-container">

                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        {this.displayApplicantInformation()}
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        {this.displayDocuments()}

                        {this.displayCases()}

                    </div>

                </div>

                {this.displayRecordings()}

            </div>
        );
    }

    displayApplicantInformation() {
        return <Form horizontal onSubmit={this.handleSubmit}>
            <h3>Personal Information</h3>
            <div style={{ zIndex: 99, position: 'relative' }}>
                <PersonalInformationComponent
                    firstName={this.state.firstName}
                    lastName={this.state.lastName}
                    middleName={this.state.middleName}
                    dateOfBirth={this.state.dateOfBirth}
                    gender={this.state.gender}
                    nationality={this.state.nationality}
                    handleInputChange={this.handleInputChange} />
                <ControlLabel>A-Number</ControlLabel>
                <div>
                    <InputGroup>
                        <InputGroup.Addon>A -</InputGroup.Addon>
                        <FormControl type="text"
                            name="aNumber"
                            value={this.state.aNumber}
                            onChange={this.handleInputChange}
                            placeholder="A-Number" />
                    </InputGroup>
                </div>
            </div>

            <h3>Contact Information</h3>
            <div style={{ marginBottom: 20, zIndex: 99, position: 'relative' }}>

                <ControlLabel>Email</ControlLabel>
                <FormControl type="text" name="email" value={this.state.email}
                    onChange={this.handleInputChange} />

                <ControlLabel>Phone Number *</ControlLabel>
                <PhoneInput type="text" style={{ zIndex: 2 }}
                    enableSearch={true}

                    country={'us'}
                    regions={['north-america', 'south-america', 'central-america']}
                    name="phoneNumber"

                    value={this.state.phoneNumber}
                    onChange={this.handlePhoneNumberChange} />

            </div>

            <h3>Primary Address</h3>

            {this.state.id &&
                (
                    <div style={{ float: 'right' }}>
                        <Link to={`/applicantDetails/${this.state.id}`}>Click here for Family Members and Address History</Link>
                    </div>
                )}
            <AddressComponent
                streetNumberName={this.state.streetNumberName}
                unitType={this.state.unitType}
                unitNumber={this.state.unitNumber}
                city={this.state.city}
                state={this.state.state}
                zipCode={this.state.zipCode}
                country={this.state.country}
                postalCode={this.state.postalCode}
                province={this.state.province}
                handleInputChange={this.handleInputChange} />

            <div style={{ marginBottom: 20, zIndex: 99, position: 'relative' }}>
                <h3>Notes and Settings</h3>

                <div style={{ zIndex: 99, paddingBottom: 10, position: 'relative' }}>
                    <ControlLabel>Notes</ControlLabel>
                    <FormControl name="notes" componentClass="textarea"
                        value={this.state.notes}
                        onChange={this.handleInputChange}
                        placeholder="Add Notes for the applicant" />
                </div>

                <div className="rowC">
                    <div className="rightPadding">
                        <label className="middle">
                            <div>
                                Active
                            </div>
                            <Switch type="checkbox" name="isActive" className="small"
                                checked={this.state.isActive}
                                onChange={this.handleIsActiveCheckboxChange} />

                        </label>
                    </div>

                    {(this.state.agencyFeatures.find(element =>
                        element.featureName === Enums.smsFeatureName && element.isActive)) &&
                        (
                            <div className="rightPadding">
                                <label className="middle">
                                    <div>
                                        SMS Updates
                                    </div>
                                    <Switch type="checkbox" name="receiveTextUpdates" className="small"
                                        checked={this.state.enableText}
                                        onChange={this.handleCheckboxChange} />
                                </label>
                            </div>)}
                    {(this.state.agencyFeatures.find(element =>
                        element.featureName === Enums.autoCallFeatureName && element.isActive)) &&
                        (
                            <div className="rightPadding">
                                <label>
                                    <div>Court Date Check</div>
                                    <Switch type="checkbox" name="runCourtDate" className="small"
                                        checked={this.state.isCourtDateCheckEnabled}
                                        onChange={this.handleCourtDateCheckboxChange} />
                                </label>
                            </div>)}
                </div>
                {this.state.lastModifiedDate &&
                    (
                        <p>
                            Last Edit Date: {ColumnFormatter.asDateTime(this.state.lastModifiedDate, null)}
                        </p>
                    )}
            </div>
            <Button type="submit" bsStyle="success">Submit</Button>

            {this.state.isSubmitting &&
                (<Loader type="ThreeDots"
                    color="#2AABD2"
                    height={30}
                    width={30} />)}

            {this.state.showErrorMessage &&
                (
                    <div style={{ marginTop: 10 }}>
                        <Alert bsStyle="danger">
                            {this.state.errorMessages.map(x => <p>{x}</p>)}
                            <Button onClick={this.handleDismissAlert}>Close Alert</Button>
                        </Alert>
                    </div>
                )}
            {this.state.showSavedMessage && !this.state.showErrorMessage &&
                <div style={{ marginTop: 10 }}>
                    <Alert bsStyle="success">Changes have been saved</Alert>
                </div>}
        </Form>;
    }

    displayDocuments() {
        const documentOptions = {
            sortName: 'documentName',
            sortOrder: 'asc',
            sizePerPage: 7,
            hideSizePerPage: true,
            paginationPosition: 'top'
        }
        let agencyKey = localStorage.getItem('agency_key');

        return (this.state.id
            && this.state.agencyFeatures.find(element => element.featureName === Enums.autoFillFeatureName && element.isActive))
            && <div>
                <h2>Documents</h2>
                {
                    this.state.pdfBlob &&
                    <div>
                        <Modal show={true} bsSize="large">
                        <Modal.Header>
                                <Modal.Title>Form</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <RenderMenu url={this.state.pdfBlob}
                                    applicantId={this.state.id}
                                    agencyKey={agencyKey}
                                    token={this.props.auth.getAccessToken()}
                                    fileName={this.state.uploadFileName} />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={this.closePdfModal}>Close</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                }

                {this.state.showDownloadError &&
                    <Label bsStyle="danger"> Error when downloading document </Label>}

                {this.state.isDownloadingDocument &&
                    <Loader type="TailSpin"
                        color="#2AABD2"
                        height={30}
                        width={30} />}
                <BootstrapTable data={this.state.documentsSelected}
                    search={true} pagination bordered={false} options={documentOptions}>

                    <TableHeaderColumn dataField='id' condensed
                        dataFormat={this.asSavedDocumentPrintButton.bind(this)}
                        width='17%'>Open Existing File</TableHeaderColumn>

                    <TableHeaderColumn dataField='id' condensed
                        dataFormat={this.asNewDocumentPrintButton.bind(this)}
                        width='15%'>Overwrite</TableHeaderColumn>

                    <TableHeaderColumn dataField='documentName' isKey
                        width='23%'>Form</TableHeaderColumn>

                    <TableHeaderColumn dataField='description'
                        width='60%'>Description</TableHeaderColumn>

                </BootstrapTable>
            </div>;
    }

    displayCases() {

        const options = {
            sortName: 'lastStatusUpdate',
            sortOrder: 'desc'
        };

        const cellEditProp = {
            mode: 'dbclick',
            blurToSave: true,
            afterSaveCell: this.onAfterSaveCell
        };
        return <div>
            <Modal show={this.state.showAddCaseModal} onHide={this.handleHideAddCaseModalClose}>
                <Modal.Header>
                    <Modal.Title>Add Case</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={this.handleAddCaseSubmit}>
                        <FormGroup>
                            <InputGroup>
                                <InputGroup.Addon>Case Type</InputGroup.Addon>
                                <FormControl type="text" name="caseType"
                                    onChange={this.handleInputChange}
                                    value={this.state.caseType} />
                                <InputGroup.Addon>Case Id</InputGroup.Addon>
                                <FormControl type="text" name="caseId"
                                    onChange={this.handleInputChange}
                                    value={this.state.caseId} />
                            </InputGroup>
                        </FormGroup>
                        <Button type="submit"> Submit </Button>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleHideAddCaseModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>

            <div>
                <h2>Cases</h2>
                <div>
                    <div style={{ position: 'absolute', left: 10 }}>
                        <Button bsStyle="info" onClick={this.handleShowAddCaseModal}>Add New Case</Button>
                    </div>

                    <div style={{ marginBottom: '5%', position: 'absolute', right: 10 }}>
                        <Button bsStyle="danger"
                            onClick={() => this.checkAllCases()}>Check All Cases</Button>
                        {this.state.isCheckingCaseStatus &&
                            <Loader type="TailSpin"
                                color="#2AABD2"
                                height={30}
                                width={30} />}
                    </div>
                </div>
                <div style={{ paddingTop: 40 }}>
                    <BootstrapTable data={this.state.cases} bordered={true} striped hover
                        cellEdit={cellEditProp} options={options}>

                        <TableHeaderColumn dataField='id' isKey hiddenOnInsert editable={false}
                            dataFormat={this.asCheckCaseStatusButton.bind(this)}
                            width='5%'>Check</TableHeaderColumn>

                        <TableHeaderColumn dataField='applicantCaseId'
                            width='25%'>Case Id</TableHeaderColumn>

                        <TableHeaderColumn dataField='caseType' dataSort
                            width='10%'>Case Type</TableHeaderColumn>

                        <TableHeaderColumn dataField='status' hiddenOnInsert editable={false}
                            width='20%'>Status</TableHeaderColumn>

                        <TableHeaderColumn
                            dataField='lastStatusUpdate'
                            hiddenOnInsert dataSort
                            editable={false} dataFormat={ColumnFormatter.asDate}
                            width='20%'>Last Update</TableHeaderColumn>

                        <TableHeaderColumn dataField='lastCheckDate' hiddenOnInsert
                            dataFormat={ColumnFormatter.asDateTime} dataSort editable={false}
                            width='20%'>Last Check Date</TableHeaderColumn>

                    </BootstrapTable>
                </div>

            </div>
        </div>;
    }

    displayRecordings() {
        const audioRecordingOptions = {
            sortName: 'createDate',
            sortOrder: 'desc'
        };

        return (this.state.agencyFeatures.find(element => element.featureName === Enums.autoCallFeatureName && element.isActive))
            &&
            <div>
                <h2>Audio Recordings</h2>

                <div>
                    <button onClick={() => this.makeCall()}>Call</button>
                </div>

                <BootstrapTable data={this.state.audioRecordings}
                    bordered options={audioRecordingOptions}>

                    <TableHeaderColumn dataField='createDate' editable={false} dataSort
                        width='10%'
                        dataFormat={ColumnFormatter.asDateTime}>Call Date</TableHeaderColumn>
                    <TableHeaderColumn dataField='transcription' editable={false} dataSort
                        width='40%'> Transcription </TableHeaderColumn>

                    <TableHeaderColumn dataField='recordingUrl' editable={false}
                        isKey width='20%'
                        dataFormat={ColumnFormatter.asAudio}> Recording </TableHeaderColumn>

                </BootstrapTable>

            </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Applicant/Applicant.js